function fInitSiteCta() {
    const siteCtaPopup = document.querySelector('.js-cta-popup');
    let cookie = Cookies.get('closedCta');
    let cookiesAccepted = Cookies.get('Cookieconsent');

    if (!siteCtaPopup) return;

    const siteCtaPopupClose = siteCtaPopup.querySelector('.js-popup-close');
    const siteCtaButton = siteCtaPopup.querySelector('.website-cta-popup a');

    if (!cookiesAccepted) {
        siteCtaPopup.classList.add('cookiebar-active');
    }

    if (cookie === undefined) {
        setTimeout(function () {            
            siteCtaPopup.classList.add('active');
        }, 1500);
    }
    
    siteCtaPopupClose.addEventListener('click', event => {
        event.preventDefault();

        siteCtaPopup.classList.remove('active');

        Cookies.set('closedCta', 'yes', { expires: 1 });      
    });

    siteCtaButton.addEventListener('click', event => {
        Cookies.set('closedCta', 'yes', { expires: 1 });
    });
} 
